import Highcharts from 'highcharts/highstock'
import {
	size as _size,
	union as _union,
	uniq as _uniq,
	values as _values,
} from 'lodash'
import moment from 'moment'

import { COLOUR, getCategoryType, getFormatter } from 'components'

import chartFunc from './chartFunc'
import { DataHandler, NumberHandler, DateTimeHandler } from 'utils'


// k line
const getDateDiff = (dateArray, reflineDateArray) => {
	if (reflineDateArray.length === 0 || dateArray.length === 0) { return 0; }

	const lastDate = dateArray[dateArray.length - 1],
		lastMonth = (lastDate.slice(0, 4) === reflineDateArray[reflineDateArray.length - 1].slice(0, 4))
			?
			reflineDateArray[reflineDateArray.length - 1].slice(4, 2)
			:
			'12',
		lastStr = reflineDateArray[reflineDateArray.length - 1],
		lastreflineDate = (lastStr.length < 6)
			?
			(lastStr + lastMonth + '01')
			:
			(lastStr.length < 8)
				?
				(lastStr + '01')
				:
				'',
		lastreflineDateTime = DateTimeHandler.getDateTime(lastreflineDate);

	for (let i = dateArray.length - 1; i >= 0; i--) {
		if (DateTimeHandler.getDateTime(dateArray[i]) <= lastreflineDateTime) { return dateArray.length - 1 - i; }
	}

	return 0;
};
const getKLineCategories = (data, tooltips, lineData) => {
	let categories = [];

	if (data && _size(data)) {
		categories = chartFunc.getCustomSelection(data, 'year');
	}

	if (tooltips && _size(tooltips)) {
		const tooltipsCategories = chartFunc.getCustomSelection(tooltips, 'year');

		categories = [ ...categories, ...tooltipsCategories ];
		categories = DataHandler.duplicatesRemover(categories).sort();
	}

	if (lineData && _size(lineData)) {
		const lineCategories = chartFunc.getCustomSelection(lineData, 'year');

		categories = [ ...categories, ...lineCategories ];
		categories = DataHandler.duplicatesRemover(categories).sort();

		const lastDateTime = DateTimeHandler.getDateTime(categories[categories.length -1]),
			lastDateTime_1   = lastDateTime + 86400000,
			lastDate_1       = moment(lastDateTime_1).format("YYYYMMDD"),
			lastDateTime_2   = lastDateTime_1 + 86400000,
			lastDate_2       = moment(lastDateTime_2).format("YYYYMMDD"),
			lastDateTime_3   = lastDateTime_2 + 86400000,
			lastDate_3       = moment(lastDateTime_3).format("YYYYMMDD"),
			lastDateTime_4   = lastDateTime_3 + 86400000,
			lastDate_4       = moment(lastDateTime_4).format("YYYYMMDD");

		categories = [
			...categories,
			lastDate_1,
			lastDate_2,
			lastDate_3,
			lastDate_4
		];
	}

	return categories;
};
// refline
const parseLineData = (
	arrLineType,
	arrLineData,
	categories,
	kLineDate,
	minDate,
	moveForward = false
) => {
	let result = {};

	for (let i = 0; i < arrLineType.length; i++) {
		const arrTempLineData = arrLineType[i].split('_'),
			tempLineType = arrTempLineData[0] + '_' + arrTempLineData[1];

		if (!(tempLineType in result)) {
			if (arrTempLineData.length > 2) {
				result[tempLineType] = {};
			} else {
				result[tempLineType] = [];
			}
		}

		if (arrTempLineData.length > 2) {
			const tempLineRate = arrTempLineData[2];

			if (!(tempLineRate in result[tempLineType])) {
				result[tempLineType][tempLineRate] = [];
			}
		}

		const lineDate = Object.keys(arrLineData[i].Data) || [],
			lineValue    = _values(arrLineData[i].Data),
			diffDate     = getDateDiff(categories, lineDate);

		let	lineData = [];

		for (let j = 0; j < lineDate.length; j++) {
			const lineDateTime = DateTimeHandler.getDateTime(lineDate[j]);

			if (moveForward) {
				if (!j) {
					lineData.push([
						lineDateTime,
						null
					]);
				} else {
					lineData.push([
						lineDateTime,
						parseFloat(lineValue[j - 1])
					]);
				}
			} else {
				if (minDate < lineDateTime && kLineDate.indexOf((lineDate[j] + (lineDate[j].length < 6 ? '12' : ''))) !== -1) {
					if (lineValue[j] && typeof lineValue[j] === 'object') {
						lineData.push([
							lineDateTime,
							parseFloat(lineValue[j][0]),
							parseFloat(lineValue[j][1])
						]);
					} else {
						lineData.push([
							lineDateTime,
							parseFloat(lineValue[j])
						]);
					}
				}
			}
		}

		if (moveForward) {
			lineData.push([
				DateTimeHandler.getDateTime(categories[categories.length - 1]),
				parseFloat(lineValue[lineValue.length - 1])
			]);
		}

		for (let j = 1 ; j <= diffDate; j++) {
			if (kLineDate.indexOf(categories[categories.length - 1 - diffDate + j]) !== -1) {
				const lineDateTime =  DateTimeHandler.getDateTime(categories[categories.length - 1 - diffDate + j]);

				lineData.push([lineDateTime, parseFloat(lineValue[lineValue.length - 1])]);
			}
		}

		lineData = DataHandler.duplicatesRemover(lineData).sort();

		if (arrTempLineData.length > 2) {
			let tempLineRate = arrTempLineData[2];

			result[tempLineType][tempLineRate] = lineData;
		} else {
			result[tempLineType] = lineData;
		}
	}

	return result;
};

	// data
const checkError = (num) => (!(num === null || num === undefined || num.length === 0) && !/^[+-]?([0-9]+([.]([0-9]*))?|[.][0-9]+)$/.test(num));
const checkDisabled = (
	data,
	length,
	minLength = 0,
	key = null
) => {
	const arrCheck = Array.isArray(data) ? data : _values(data);

	let disabledSubmit = arrCheck.length < (minLength ? minLength : length),
		disabledReset = arrCheck.length === 0;

	if (!disabledSubmit || !disabledReset) {
		const arrCheckSubmit = arrCheck.filter((item) => {
				const value = key ? item[key] : item,
					err = checkError(value);

				return minLength ? !err : err;
			}),
			arrCheckReset = arrCheck.filter((item) => {
				const value = key ? item[key] : item,
					err = checkError(value);

				return !err;
			});

		disabledSubmit = minLength ? arrCheckSubmit.length < minLength : arrCheckSubmit.length > 0;
		disabledReset = arrCheckReset.length === 0;
	}

	return {
		disabled_submit: disabledSubmit,
		disabled_reset: disabledReset
	};
};
const getTypeData = (data, dataType) => {
	if (Array.isArray(data)) { return data; }

	const YearData = data?.YearData ?? null;
	const PeriodData = data?.PeriodData ?? null;

	const Data = data?.Data ?? null;

	switch (dataType) {
		case undefined: return Data ?? [];

		case 'year': return YearData ?? Data ?? [];

		case 'quarter': return PeriodData ?? Data ?? [];

		default: return [];
	}
};

const getSDMultiple = (avg, sd) => (sd + avg);

const getSearchPool = (fetchData) => {
		const searchColumn = (fetchData && fetchData.search_column) ? fetchData.search_column : [];

		let searchPool = [];

		for (let i = 0; i < searchColumn.length; i++) {
			searchPool = _union(searchPool, fetchData.data.map((item) => (item[searchColumn[i]])));
		}

		return searchPool;
	},

	// fullscreen
	FULLSCREEN = [
		'fullscreenchange',
		'webkitfullscreenchange',
		'mozfullscreenchange',
		'msfullscreenchange'
	],
	checkFullscreen = () => (document.fullScreenElement || document.mozFullScreen || document.webkitIsFullScreen || document.msFullscreenElement),


	// app
	dataAppInitHandler = ({ data, mapping, refline }) => {
		const mappingData = {
				open    : data[mapping.open].Data,
				high    : data[mapping.high].Data,
				low     : data[mapping.low].Data,
				close   : data[mapping.close].Data,
				volume  : data[mapping.volume].Data,
				percent : data[mapping.percent].Data,
				change  : data[mapping.change].Data
			},
			arrReflineType  = refline ? Object.keys(refline) : [],
			arrReflineData  = _values(refline);

		let high     = [], low 			  = [], kLineDate  = [],
			ohlc       = [], volume		  = [],
			categories = [], seriesData = [],
			minDate    = new Date().getTime();

		if (data && _size(data)) {
			categories = chartFunc.getCustomSelection(data, 'year');
		}

		for (let i = 0; i < categories.length; i++) {
			const dailyTradingShares = mappingData.volume[categories[i]];

			if (dailyTradingShares != null) {
				const date     = DateTimeHandler.getDateTime(categories[i]),
					dailyOpen    = (typeof Number(mappingData.open[categories[i]]) === 'number' && !(typeof mappingData.open[categories[i]] === 'string' && mappingData.open[categories[i]].length === 0)) ? mappingData.open[categories[i]] : null,
					dailyHigh    = (typeof Number(mappingData.high[categories[i]]) === 'number' && !(typeof mappingData.high[categories[i]] === 'string' && mappingData.high[categories[i]].length === 0)) ? mappingData.high[categories[i]] : null,
					dailyLow     = (typeof Number(mappingData.low[categories[i]]) === 'number' && !(typeof mappingData.low[categories[i]] === 'string' && mappingData.low[categories[i]].length === 0)) ? mappingData.low[categories[i]] : null,
					dailyClose   = (typeof Number(mappingData.close[categories[i]]) === 'number' && !(typeof mappingData.close[categories[i]] === 'string' && mappingData.close[categories[i]].length === 0)) ? mappingData.close[categories[i]] : null,
					dailyVolume  = NumberHandler.floatFormatter(dailyTradingShares, 0),//floatFormatter(dailyTradingShares / 1000, 0)
					dailyPercent = (typeof Number(mappingData.percent[categories[i]]) === 'number' && !(typeof mappingData.percent[categories[i]] === 'string' && mappingData.percent[categories[i]].length === 0)) ? mappingData.percent[categories[i]] : null,
					dailyChange  = (typeof Number(mappingData.change[categories[i]]) === 'number' && !(typeof mappingData.change[categories[i]] === 'string' && mappingData.change[categories[i]].length === 0)) ? mappingData.change[categories[i]] : null;

				if (dailyHigh !== undefined && dailyHigh !== null) { high[high.length] = dailyHigh; }
				if (dailyLow !== undefined && dailyLow !== null) { low[low.length] = dailyLow; }

				minDate = (minDate > date) ? date : minDate;

				if (isNaN(dailyClose) || dailyClose === '' || dailyClose === 0
					|| dailyOpen === '' || dailyOpen === 0
					|| dailyHigh === '' || dailyHigh === 0
					|| dailyLow  === '' || dailyLow  === 0
					|| dailyPercent  === ''
					|| dailyChange  === ''
					|| isNaN(dailyVolume) || dailyVolume === 0) { continue; }

				ohlc[ohlc.length]           = [ date, dailyOpen, dailyHigh, dailyLow, dailyClose, dailyPercent, dailyChange ];
				kLineDate[kLineDate.length] = categories[i];
				volume[volume.length]       = [ date, dailyVolume ];
			}
		}

		seriesData = [
			{
				type : 'candlestick',
				name : '股票走勢',
				id   : 'aapl',
				data : ohlc
			},
			{
				type  : 'column',
				name  : data[mapping.volume].ChineseAccount + data[mapping.volume].UnitRef,
				id    : 'volume',
				data  : volume,
				yAxis : 1
			}
		];

		// refline
		const reflineData = parseLineData(
				arrReflineType,
				arrReflineData,
				categories,
				kLineDate,
				minDate
			);

		return {
			series_data: seriesData,
			ref_line_data: reflineData
		};
	},


	// k line
	getClassicKLineOptions = (
		props,
		range_switcher_option,
		seriesData,
		chartRange
	) => {
		let fetchData = props.fetch_data;

		if (fetchData.Kline) {
			fetchData = fetchData.Kline;
		}

		const {
				title,
				stock,
				dataRangeMode,
				dataRange,
				option,
				colour_theme,
				onResetXAxisHandler
			} = props,
			chartRangeUpdated = chartRange
				?
				chartRange
				:
				getChartRangeOption(
					fetchData,
					false,
					dataRangeMode,
					dataRange,
					onResetXAxisHandler,
					range_switcher_option
				),
			stockName = fetchData ? fetchData.stock_name : stock ? stock.stock_name : '',
			isPercentCompare = option && 'compare' in option && option.compare === 'percent';

		let options = {
			title: {
				text: title ? `${!(title.includes('指數')) ? `${stockName} - ` : ''}${title}` : ''
			},
			series: seriesData,
			xAxis: {
				min: chartRangeUpdated.start,
				max: chartRangeUpdated.end
			},
			credits: {
				enabled: option ? !option.no_credit : true
			}
		};

		if (isPercentCompare) {
			const dateType = getCategoryType(fetchData);

			options = {
				...options,
				chart: {
					height: 450,
				},
				yAxis: [{
					labels: {
						align: 'left',
						formatter: function () {
							return `<span style="color: ${COLOUR.text[colour_theme]}">${((this.value > 0) ? ' + ' : '')}${this.value}%</span>`;
						}
					}
	      }],
				plotOptions: {
					// line: {
					// 	tooltip: {
					// 		// pointFormatter: function () {
					// 		// 	let tooltip = Highcharts.dateFormat(`<span>${getFormatter(dateType)}</span>`, this.x);
					// 		// 	tooltip += `<br/>${this.series.name}: ${Highcharts.numberFormat(this.y, 2, '.', ',')} (${Highcharts.numberFormat(this.change, 2, '.', ',')}%)`;
					// 		//
					// 		// 	return tooltip;
					// 		// }
					// 	}
					// },
					series: {
						showInNavigator: true,
						compare: 'percent'
					}
				},
				tooltip: {
					shared: true,
					split: false,
					valueDecimals: 2,
					useHTML: true,
					formatter: function () {
						const date = Highcharts.dateFormat(`<span>${getFormatter(dateType)}</span>`, this.x);

						let tooltip = `<span>${date}</span>`;

						if (this.points) {
							for (var i = 0; i < this.points.length; i++) {
								tooltip += `<br/><span>
									<span style="color: ${this.points[i].color}">\u25CF</span>
										<b>
											${this.points[i].series.name}: ${NumberHandler.comma(NumberHandler.floatFormatter(this.points[i].y, 2))}${this.points[i].series.userOptions.unit ?? ''}
										</b>
									</span>`;
							}
						}

						return tooltip;
					},
				}
			}
		}

		if (options.xAxis.min === null) { delete options.xAxis['min'] }

		if (options.xAxis.max === null) { delete options.xAxis['max'] }

		return options;
	},
	initKLineData = (
		{
			data,
			mapping,
			refline,
			Line,
			tooltips
		},
		enableDataLabels = false
	) => {
		const categories = getKLineCategories(data, tooltips, Line);
		let seriesData = [],
			result = { categories: categories };
		const ignoreData = {};
		if (mapping.open) {// k line
			const arrMappingKey = Object.keys(mapping),
				arrReflineType  	= refline ? Object.keys(refline) : [],
				arrReflineData  	= _values(refline),
				arrLineType     	= Line ? Object.keys(Line) : [],
				arrLineData     	= Line ? _values(Line) : [];

			let mappingData = {};

			for (let i = 0; i < arrMappingKey.length; i++) {
				const key = arrMappingKey[i],
					account = mapping[key];

				mappingData[key] = getTypeData(data[account]);
			}

			let kLineDate = [], minDate = new Date().getTime(),
				ohlc   		 	= [], volume  = [];

			for (let i = 0; i < categories.length; i++) {
				const date = categories[i],
					dailyTradingShares = mappingData.volume[date];

				if (!dailyTradingShares && (!Line || !_size(Line))) { continue; }

				const dateTime = DateTimeHandler.getDateTime(date),
					dailyOpen    = Number(mappingData.open[date]),
					dailyHigh    = Number(mappingData.high[date]),
					dailyLow     = Number(mappingData.low[date]),
					dailyClose   = Number(mappingData.close[date]),
					dailyVolume  = NumberHandler.floatFormatter(dailyTradingShares, 0);//floatFormatter(dailyTradingShares / 1000, 0);

				minDate = (minDate > dateTime) ? dateTime : minDate;

				if ((isNaN(dailyClose) || dailyClose === 0
					|| isNaN(dailyOpen) || dailyOpen === 0
					|| isNaN(dailyHigh) || dailyHigh === 0
					|| isNaN(dailyLow) || dailyLow  === 0
					|| isNaN(dailyVolume) || dailyVolume === 0) && (!Line || !_size(Line))) { continue; }
				
				if ((isNaN(dailyClose) || dailyClose === 0) &&
					(isNaN(dailyOpen) || dailyOpen === 0) &&
					(isNaN(dailyHigh) || dailyHigh === 0) &&
					(isNaN(dailyLow) || dailyLow  === 0) &&
					(isNaN(dailyVolume) || dailyVolume === 0)) {
					ignoreData[dateTime] = date;
					continue;
				}

				ohlc[ohlc.length] = [
					dateTime,
					dailyOpen ?? null,
					dailyHigh ?? null,
					dailyLow ?? null,
					dailyClose ?? null
				];
				kLineDate[kLineDate.length] = date;
				volume[volume.length] = [ dateTime, (dailyVolume && !isNaN(dailyVolume)) ? dailyVolume : null ];
			}

			seriesData = [
				{
					id           : 'aapl',
					type         : 'candlestick',
					name         : '股票走勢',
					data         : ohlc,
					dataLabels 	 : { enabled: enableDataLabels },
					showInLegend : false
				},
				{
					id           : 'volume',
					type         : 'column',
					name         : data[mapping.volume].ChineseAccount + data[mapping.volume].UnitRef,
					data         : volume,
					dataLabels 	 : { enabled: enableDataLabels },
					yAxis        : 1,
					showInLegend : false
				}
			];

			// refline
			const reflineData = parseLineData(
					arrReflineType,
					arrReflineData,
					categories,
					kLineDate,
					minDate
				),
				lineData = parseLineData(
					arrLineType,
					arrLineData,
					categories,
					kLineDate,
					minDate,
					true
				);

			result = {
				...result,
				series_data   : seriesData,
				ref_line_data : reflineData,
				line_data     : lineData,
				ignore_data	  : ignoreData
			};
		} else {
			const arrMappingValue = _values(mapping);

			let accountData = null;

			for (let i = 0; i < arrMappingValue.length; i++) {
				const account = arrMappingValue[i];

				accountData = data[account];

				const dataUnparsed = getTypeData(accountData);

				let arrAccountData = [];

				for (let j = 0; j < categories.length; j++) {
					const date    = categories[j],
						dateTime    = DateTimeHandler.getDateTime(date),
						accountData = Number(dataUnparsed[date]);

					arrAccountData[arrAccountData.length] = [ dateTime, accountData ];
				}

				seriesData[seriesData.length] = {
					id           : account,
					type         : 'line',
					name         : accountData.ChineseAccount,
					data         : arrAccountData,
					dataLabels 	 : { enabled: false },
					showInLegend : true
				};
			}

			result = {
				...result,
				series_data: seriesData
			};
		}

		return result;
	},
	getChartRangeOption = (
		fetchData,
		updateXAxis,
		dataRangeMode,
		dataRange,
		onResetXAxisHandler,
		range_switcher_option
	) => {
		const { data, Line } = fetchData;

		let start    = 0,
			end        = 0,
			categories = getKLineCategories(data, Line),
			rangeMode  = dataRangeMode ? dataRangeMode : range_switcher_option.recent;

		if (categories.length === 0) { return { start: start, end: end }; }

		if (rangeMode === 'all') {
			start = DateTimeHandler.getDateTime(categories[0]);
			end = DateTimeHandler.getDateTime(categories[categories.length - 1]);
		} else if (typeof rangeMode === 'number') {
			if (categories.length > rangeMode) {
				start = DateTimeHandler.getDateTime(categories[categories.length - rangeMode]);
				end = DateTimeHandler.getDateTime(categories[categories.length - 1]);
			} else {
				start = DateTimeHandler.getDateTime(categories[0]);
				end = DateTimeHandler.getDateTime(categories[categories.length - 1]);
			}
		} else if (rangeMode === 'custom') {
			start = dataRange.start ? DateTimeHandler.getDateTime(dataRange.start) : DateTimeHandler.getDateTime(categories[0]);
			end = dataRange.end ? DateTimeHandler.getDateTime(dataRange.end) : DateTimeHandler.getDateTime(categories[categories.length - 1]);
		}

		if (updateXAxis) {
			onResetXAxisHandler(start, end);
		}

		return { start: start, end: end };
	},
	getDefaultRate = (refline_type, refline_rate) => {
		let defaultRate = { up: false, bottom: false };

		if (refline_type  === 'ua60021_cp') {
			defaultRate.up = 'x6';
			defaultRate.bottom = 'x3';
		} else if (refline_type  === 'ua60022_cp') {
			defaultRate.up = 'x14';
			defaultRate.bottom = 'x25';
		} else if (refline_type === 'ua60023_cp') {
			defaultRate.up = 'p6';
			defaultRate.bottom = 'p3';
		} else {
			defaultRate.up = refline_rate[0];
			defaultRate.bottom = refline_rate[(refline_rate.length > 1) ? 1 : 0];
		}

		return defaultRate;
	},
	getLineSeriesData = (
		lines,
		noUpdate,
		activeReflineType,
		lineData,
		defaultLines = {},
		defaultLineData = {},
		ignoreData = null,
	) => {
		if (!lines) { return {}; }

		const CHART_TYPE = [
				'area',
				'arearange',
				'areaspline',
				'areasplinerange',
				'bar',
				'column',
				'columnrange',
				'gauge',
				'line',
				'pie',
				'scatter',
				'solidgauge',
				'spline',
				'waterfall'
			],
			attr = {
				colour: COLOUR.series.dark,
				chinese_account: _uniq(_values(lines).map((v, k) => (v.ChineseAccount)))
			},
			arrLineDataKey = Object.keys(lineData);

		let count		 = 0,
			series 		 = [],
			lineColour = '';

		if (activeReflineType) {
			const arrDefaultLineDataKey = Object.keys(defaultLineData);

			for (let i = 0; i < arrDefaultLineDataKey.length; i++) {
				const key = arrDefaultLineDataKey[i];

				if (!(key in activeReflineType)) { continue; }

				const style = defaultLines[key].Style,
					name = defaultLines[key].ChineseAccount;

				if (name.includes('空防守')) {
					lineColour = '#ef5350';
				} else if (name.includes('多空點')) {
					lineColour = '#ffa500';
				} else if (name.includes('多防守')) {
					lineColour = '#4abf70';
				}
				series.push({
					id           : key,
					type         : !CHART_TYPE.includes(style) ? 'line' : style,
					name         : name,
					data         : ignoreData ? defaultLineData[key].filter(d=>!ignoreData[d[0]]) : defaultLineData[key],
					dataLabels	 : { enabled: false },
					color        : lineColour,
					lineWidth 	 : 1,
					step         : false,
					label        : {
						enabled: true,
						onArea: true
					},
					yAxis        : 0,
					showInLegend : false
				});
			}

			for (let i = 0; i < arrLineDataKey.length; i++) {
				const key = arrLineDataKey[i];

				if (!(key in activeReflineType)) { continue; }

				lineColour = COLOUR.series.dark[count + i + 3];

				let name = attr.chinese_account[i];

				if (!Array.isArray(lineData[key])) {
					series.push({
						type         : 'line',
						name         : name + '[買進]',
						data         : lineData[key][activeReflineType[key].up],
						dataLabels	 : { enabled: false },
						color        : lineColour,
						step         : false,
						label        : {
							enabled: true,
							onArea: true
						},
						yAxis        : 0,
						showInLegend : false
					});
					series.push({
						type         : 'line',
						name         : name + '[賣出]',
						data         : lineData[key][activeReflineType[key].bottom],
						dataLabels	 : { enabled: false },
						color        : lineColour,
						step         : false,
						label        : {
							enabled : true,
							onArea: true
						},
						yAxis        : 0,
						showInLegend : false
					});
				} else {
					const style = lines[key].Style,
						lineWidth = (name.includes('EMA')) ? 1 : 2;

					lineColour = (!name.includes('布林')) ? lineColour : COLOUR.series.dark[0];

					series.push({
						id           : key,
						name         : name,
						type         : !CHART_TYPE.includes(style) ? 'line' : style,
						data         : lineData[key],
						dataLabels	 : { enabled: false },
						color        : lineColour,
						lineWidth 	 : lineWidth,
						step         : false,
						label        : {
							enabled: true,
							onArea: true
						},
						yAxis        : 0,
						showInLegend : false
					});
				}

				if (i + 3 === COLOUR.series.dark.length - 1) { count++; }
			}
		}

		if (noUpdate) {
			series.push({
				type: 'vbp',
				linkedTo: 'aapl',
				visible: true,
				params: {
					volumeSeriesID: 'volume'
				},
				dataLabels: {
					enabled: false
				},
				zoneLines: {
					enabled: false
				},
				pointPadding: 1
			});
		}

		return series;
	},
	getReflineList = (line) => {
		let lineList      = {},
			lineType        = Object.keys(line) || [],
			lineTypeRate    = _values(line),
			chineseAccounts = _uniq(lineTypeRate.map((v) => (v.ChineseAccount)));

		for (let i = 0; i < lineType.length; i++) {
			const tempReflineKeyArray = lineType[i].split('_'),
				tempReflineType = tempReflineKeyArray[0] + '_' + tempReflineKeyArray[1],
				value = lineTypeRate[i].ChineseAccount;

			let lineColour = COLOUR.series.dark[chineseAccounts.indexOf(lineTypeRate[i].ChineseAccount) + 3];

			if (value.includes('空防守')) {
				lineColour = '#ef5350';
			} else if (value.includes('多空點')) {
				lineColour = '#ffa500';
			} else if (value.includes('多防守')) {
				lineColour = '#4abf70';
			}

			if (!(tempReflineType in lineList)) {
				lineList[tempReflineType] = {
					key   : tempReflineType,
					value : lineTypeRate[i].ChineseAccount,
					color : lineColour,
					rate  : false
				}
			}

			if (tempReflineKeyArray.length > 2) {
				if (!lineList[tempReflineType].rate) {
					lineList[tempReflineType].rate = [];
				}

				lineList[tempReflineType].rate.push(tempReflineKeyArray[2]);
			}
		}

		return _values(lineList);
	}

const getHorizLineValue = (y, series=[], defaultUnit=null) => {
	if(y && series){
		let value;
		if (series.type === 'arearange') {
		value = Highcharts.numberFormat(y, 2, '.', ',');
		} else if (series.type === 'column' && series.stacking) {
		value = NumberHandler.comma(NumberHandler.getUnitNumber(y));
		} else {
		value = NumberHandler.comma(NumberHandler.floatFormatter(y, 2));
		}
		return value + (series.unit ? series.unit : defaultUnit??'')
	}else{
		return null
	}
}

export default {
	checkError,
	checkDisabled,
	getTypeData,

	getSDMultiple,

	getSearchPool,
	// getTableData,

	FULLSCREEN,
	checkFullscreen,

	dataAppInitHandler,

	getClassicKLineOptions,
	initKLineData,
	getChartRangeOption,
	getDefaultRate,
	getLineSeriesData,
	getReflineList,
	getHorizLineValue
}
